import { EditIcon, Trash2Icon } from 'lucide-react'

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  RowActionsMenu,
} from '@/components/ui'
import type { CellContext } from '@/components/ui/table/types'
import {
  DeleteDocumentsDialog,
  type Document,
  ProcessDocumentsButton,
} from '@/modules/documents'
import {
  hasDocumentFailed,
  isDocumentProcessing,
} from '@/modules/documents/status'
import { useDialogActions } from '@/stores/dialog'
import { EditDocumentDialog } from '../../dialogs/EditDocumentDialog'

export const RowActionsCell = (cell: CellContext<Document, unknown>) => {
  const { openDialog } = useDialogActions()
  const document = cell.row.original
  const isProcessing = isDocumentProcessing(document)

  return (
    <RowActionsMenu label="Document actions">
      <DropdownMenuItem
        onClick={() => openDialog(EditDocumentDialog.id, document)}
      >
        <EditIcon className="size-4" />
        Change folder
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <ProcessDocumentsButton
          theme="ghost"
          table={cell.table}
          documentsToProcess={[document]}
        >
          {hasDocumentFailed(document) ? 'Retry' : 'Process'} document
        </ProcessDocumentsButton>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => openDialog(DeleteDocumentsDialog.id, [document])}
        destructive
        disabled={isProcessing}
      >
        <Trash2Icon className="h-4 w-4" />
        Delete document
      </DropdownMenuItem>
    </RowActionsMenu>
  )
}
